interface State {
  [key: string]: number;
}
export const getStateDiff = (newState: State, currentState: State): State => {
  const diff: State = {};
  for (const key in newState) {
    if (currentState.hasOwnProperty(key)) {
      diff[key] = newState[key] - currentState[key];
    } else {
      diff[key] = newState[key];
    }
  }
  for (const key in currentState) {
    if (!newState.hasOwnProperty(key)) {
      diff[key] = -currentState[key];
    }
  }

  return diff;
};

export const getFoundDiff = (currentState: State): State => {
  const diff: State = {};
  const newState: State = {
    wrong_item_received: 0,
    item_damaged: 0,
    not_found: 0,
    partial_not_found: 0,
    ofd_db_lost_damage: 0,
  };

  for (const key in newState) {
    if (currentState.hasOwnProperty(key)) {
      diff[key] = newState[key] - currentState[key];
    } else {
      diff[key] = newState[key];
    }
  }
  for (const key in currentState) {
    if (!newState.hasOwnProperty(key)) {
      diff[key] = -currentState[key];
    }
  }
  return diff;
};
